export default class Favorite {
  constructor(contents) {
    this.contents = contents;
    if (!this.contents) {
      return;
    }
    this.favorites = contents.querySelectorAll('.c-card__favorite')

    this.setup()
  }

  setup () {
    this.favorites.forEach((elm, index) => {
      elm.addEventListener('mousedown', (event) => {
        let target = event.currentTarget;
        if (target!=document.activeElement)
        {
          event.preventDefault();
          if( target.classList.contains('on') == true ){
            target.classList.remove("on");
          }
          else
          {
            target.classList.add("on");
          }
        }
      })
    });
    this.favorites.forEach((elm, index) => {
      elm.addEventListener('click', (event) => {
        let target = event.currentTarget;
        if (target==document.activeElement)
        {
          event.preventDefault();
          if( target.classList.contains('on') == true ){
            target.classList.remove("on");
          }
          else
          {
            target.classList.add("on");
          }
        }
      })
    });
  }

}